import { unsafeCSS, css, html } from "lit";
import { query } from "lit/decorators.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
import "../../atom/Icon/index.js";
import "../Checkbox/index.js";
import { rif } from "../../../helpers/renderIf.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { getOptionClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfOption = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.value = "";
    this.disabled = false;
    this.dsf_active = false;
    this.dsf_selected = false;
    this.dsf_multiselect = false;
    this.dsf_subsection = false;
  }
  getOptionText() {
    var _a;
    return ((_a = this.textContent) == null ? void 0 : _a.trim()) || "";
  }
  updated() {
    if (this.dsf_multiselect && this._checkbox) {
      this._checkbox.setTabIndex(-1);
    }
  }
  handleCheckboxClick(event) {
    event.preventDefault();
  }
  handleClick(ev) {
    if (this.disabled) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
    }
  }
  render() {
    const optionClasses = getOptionClasses(this);
    return html`<div
      class=${optionClasses}
      role="option"
      aria-disabled=${this.disabled ? "true" : "false"}
      part="option"
      @click=${this.handleClick}
    >
      ${rif(
      this.dsf_multiselect,
      html`<dsf-checkbox
          .dsf_checked=${this.dsf_selected}
          .disabled=${this.disabled}
          class="-mr-4"
          @click=${this.handleCheckboxClick}
        ></dsf-checkbox>`
    )}
      <slot name=${DsfOption.iconSlot}></slot>
      <div class="flex flex-auto flex-col truncate">
        <div class="flex flex-auto gap-12 truncate" title=${ifDefined(this.getOptionText())}>
          <slot></slot>
        </div>
        <span
          class=${`dsf-text-xxs truncate ${!this.dsf_selected ? "text-neutral-400" : ""}`}
          title=${ifDefined(this.dsf_subtitle)}
          >${this.dsf_subtitle}</span
        >
      </div>
      ${rif(
      this.dsf_selected && !this.dsf_multiselect,
      html`<dsf-icon dsf_name="Check" class="ml-4 h-16 w-16 shrink-0"></dsf-icon>`
    )}
      ${rif(
      this.dsf_subsection,
      html`<dsf-icon dsf_name="ChevronRight" class="ml-4 h-16 w-16 shrink-0"></dsf-icon>`
    )}
    </div>`;
  }
};
DsfOption.iconSlot = "icon-content";
DsfOption.slotSelector = unsafeCSS(`slot[name="${DsfOption.iconSlot}"]`);
DsfOption.styles = [
  ...BaseComponent.styles,
  css`
      ${DsfOption.slotSelector}::slotted(dsf-icon) {
        width: calc(var(--dsf-base-size) * 1.6);
        height: calc(var(--dsf-base-size) * 1.6);
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfOption.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfOption.prototype, "disabled", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfOption.prototype, "dsf_active", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfOption.prototype, "dsf_selected", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfOption.prototype, "dsf_multiselect", 2);
__decorateClass([
  prop({ type: String })
], DsfOption.prototype, "dsf_subtitle", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfOption.prototype, "dsf_subsection", 2);
__decorateClass([
  query("dsf-checkbox")
], DsfOption.prototype, "_checkbox", 2);
DsfOption = __decorateClass([
  defineElement("dsf-option")
], DsfOption);
export {
  DsfOption
};
